var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { leaveBreadcrumb } from 'app/utils/error';
/**
 * Download on desktop or open in new tab on mobile. Opening in new tab is safer on mobile.
 * @param render Image blob
 * @param action
 * @returns
 */
export const saveToDevice = (output, action = 'download') => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const [render] = output !== null && output !== void 0 ? output : [];
    if (!render || !render.data || !render.data.size) {
        leaveBreadcrumb({
            output: (_a = output === null || output === void 0 ? void 0 : output.length) !== null && _a !== void 0 ? _a : -1,
            action,
            render: Boolean(render),
            size: Boolean(render === null || render === void 0 ? void 0 : render.data),
            data: (_c = (_b = render === null || render === void 0 ? void 0 : render.data) === null || _b === void 0 ? void 0 : _b.size) !== null && _c !== void 0 ? _c : -1,
        }, '[Export] Save to device not possible');
        throw new Error('Invalid data');
    }
    const { body } = document;
    const blobUrl = URL.createObjectURL(render.data);
    if (action === 'open_in_window') {
        const popup = window.open(blobUrl, '_blank');
        return new Promise((resolve, reject) => {
            popup.onerror = () => {
                console.log('Somethin went wrong');
                window.URL.revokeObjectURL(blobUrl);
                reject();
            };
            popup.onclose = () => {
                window.URL.revokeObjectURL(blobUrl);
                resolve();
            };
        });
    }
    const link = document.createElement('a');
    // dummy link content
    const linkContent = document.createElement('span');
    linkContent.innerHTML = '&nbsp;';
    link.appendChild(linkContent);
    link.style.display = 'none';
    link.href = blobUrl;
    switch (action) {
        case 'download':
            link.download = render.name;
            break;
        case 'open_in_tab':
            link.target = '_blank';
            break;
        default:
            break;
    }
    body.appendChild(link);
    link.click();
    return new Promise(resolve => {
        setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl);
            if (link) {
                body.removeChild(link);
            }
            resolve();
        }, 1000);
    });
});
